import React, { useState } from "react";
import "./Header.css";
import Logo from "../../Images/logo.png";
import { Badge, Button, IconButton, Menu, MenuItem } from "@mui/material";
import { HomeOutlined, NotificationsNoneOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetMessageNotificationCount,
  resetNotificationCount,
  resetTotalCount,
  selectMessageNotificationCount,
  selectNotificationCount,
  selectTotalNotificationCount,
} from "state/notification";
function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const totalNotificationCount = useSelector((state) =>
    selectTotalNotificationCount(state)
  );
  const notificationCount = useSelector((state) =>
    selectNotificationCount(state)
  );
  const messageNotificationCount = useSelector((state) =>
    selectMessageNotificationCount(state)
  );

  return (
    <div className="navBar-container">
      <div className="header-container">
        <div className="logo-container">
          <img src={Logo} alt="logo-csc" />
        </div>
        <div className="header-right-container">
          <Button
            className="header-right-container-button"
            startIcon={<HomeOutlined />}
            sx={{
              textTransform: "none",
              color: "#1E5EFF",
              fontSize: "14px",
              fontWeight: "bold",
              width: "185px",
              height: "40px",
              border: "2px solid",
              borderColor: "#1E5EFF",
              borderRadius: "4px",
            }}
            onClick={() => navigate("/")}
          >
            Dashboard CS ERP
          </Button>
          <div className="header-right-container-notification">
            <IconButton
              onClick={(event) => {
                dispatch(resetTotalCount({}));
                setAnchorEl(event.currentTarget);
              }}
            >
              <Badge
                badgeContent={totalNotificationCount}
                color="error"
                sx={{
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                <NotificationsNoneOutlined
                  sx={{ fontSize: "24px", color: "#979797" }}
                />
              </Badge>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={isOpen}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <MenuItem
                sx={{
                  height: "70px",
                  color: "#000",
                  fontSize: "14px",
                }}
                onClick={() => {
                  dispatch(resetMessageNotificationCount({}));
                  navigate("/messages");
                }}
              >
                Nouveaux messages : {messageNotificationCount}
              </MenuItem>
              <MenuItem
                sx={{
                  height: "70px",
                  color: "#000",
                  fontSize: "14px",
                }}
                onClick={() => {
                  dispatch(resetNotificationCount({}));
                  navigate("/");
                }}
              >
                Nouvelles notifications : {notificationCount}
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
